import { render, staticRenderFns } from "./GoalDescriptionConfig.vue?vue&type=template&id=17b2d216&"
import script from "./GoalDescriptionConfig.vue?vue&type=script&lang=js&"
export * from "./GoalDescriptionConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports